import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Location } from './../../../model/location';

declare const google;
@Component({
    selector: 'app-maps-autocomplete',
    templateUrl: './maps-autocomplete.component.html',
    styleUrls: ['./maps-autocomplete.component.scss'],
    standalone: false
})
export class MapsAutocompleteComponent implements OnInit {
	@ViewChild('addresstext') addresstext: any;

	@Input()
	flagRaio? = false;

	@Input()
	radius? = 0;

	@Input()
	lat?;

	@Input()
	lon?;

	@Input()
	address? = '';

	@Input()
	location?: Location;

	@Output()
	selectAddress = new EventEmitter<any>();

	ranges = [];

	constructor() {
		this.generateRanges();
	}

	generateRanges() {
		for (let a = 1; a <= 100; a += 5) {
			this.ranges.push(a);
			if (a == 1) {
				a = 0;
			}
		}
	}

	ngOnInit() {
		this.startPlaces();
		if (!this.location) {
			this.location = new Location();
			this.location.range = this.radius;
			this.location.address = this.address;
			this.location.coordinates.lat = this.lat;
			this.location.coordinates.lon = this.lon;
		} else {
			this.location = new Location();
		}
	}

	onChangeLocal(event) {
		this.startPlaces();
		this.location.coordinates.lat = null;
		this.location.coordinates.lon = null;
		this.emit();
	}
	startPlaces() {
		const that = this;
		setTimeout(() => {
			const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, {
				componentRestrictions: { country: 'BR' },
				types: ['geocode']
			});

			google.maps.event.addListener(autocomplete, 'place_changed', () => {
				const place = autocomplete.getPlace();
				const lat = place.geometry.location.lat();
				const lon = place.geometry.location.lng();
				that.location.coordinates.lat = lat;
				that.location.coordinates.lon = lon;
				that.location.address = place.formatted_address;
				that.emit();
			});
		}, 0);
	}
	emit() {
		this.selectAddress.emit(this.location);
	}
}
